export enum Availability {
  NEXT_48_HOURS = 'NEXT_48_HOURS',
  THIS_WEEK = 'THIS_WEEK',
  NEXT_2_WEEKS = 'NEXT_2_WEEKS',
  NEXT_30_DAYS = 'NEXT_30_DAYS'
}
